import { SectionHeading } from "@/components/shared/SectionHeading";
import { RevealStagger, RevealItem } from "@/components/shared/Reveal";
import { Building2, Truck, UserCog, Map as MapIcon } from "lucide-react";

const SOURCES = [
  { label: "Brokers", icon: Building2 },
  { label: "Carriers", icon: Truck },
  { label: "Owner Operators", icon: UserCog },
  { label: "RelayRigs Marketplace & Relief Requests", icon: MapIcon },
];

export const BrokerDriverBenefit = () => (
  <section data-testid="broker-driver-benefit-section" className="py-24 md:py-28 bg-white">
    <div className="max-w-5xl mx-auto px-5 md:px-8">
      <SectionHeading eyebrow="For Drivers" title="More Connections for Drivers." testId="broker-driver-benefit" />
      <p className="mt-5 text-rr-muted max-w-2xl">
        RelayRigs also helps drivers develop relationships with multiple transportation businesses. Drivers retain their own RelayRigs account across every relationship.
      </p>
      <RevealStagger className="mt-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {SOURCES.map((s) => (
          <RevealItem key={s.label}>
            <div data-testid={`broker-driver-benefit-source-${s.label.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="h-full bg-rr-surface border border-rr-line rounded-xl p-5 text-center">
              <s.icon size={22} className="text-rr-orange mx-auto mb-3" />
              <p className="text-sm font-bold text-rr-navy">{s.label}</p>
            </div>
          </RevealItem>
        ))}
      </RevealStagger>
    </div>
  </section>
);
